<template lang="pug">
  .b-spec-auto-choose(data-testid="auto-choose-dialog")
    ._title Автовыбор откликов
    ._hint Позиций отмечено: {{ count }}. Выбор пройдёт по позициям, где есть отклики в состоянии «Новый»; утверждённые заказчиком позиции не меняются.
    label._mode(
      v-for="option in MODES"
      :key="option.value"
      :class="{ active: mode === option.value }"
      :data-testid="`auto-choose-mode-${option.value}`"
      )
      input._radio(type="radio" :value="option.value" v-model="mode")
      ._text
        ._name {{ option.title }}
        ._desc {{ option.desc }}
    label._include
      input(type="checkbox" data-testid="auto-choose-include-chosen" v-model="includeChosen")
      span Затрагивать позиции, по которым отклик уже выбран
    ._hint(v-if="includeChosen") Выбор и разделение скидки по таким позициям пересчитаются по выбранному режиму; заказчик увидит изменённое предложение.
    ._buttons
      Btn(blue data-testid="auto-choose-submit" @click="submit") Выбрать
      Btn(grey @click="$emit('finish', false)") Отмена
</template>

<script>
/** Режимы автовыбора: код уходит на сервер, описание показывается в окне. */
const MODES = [
  {
    value: 'customer',
    title: 'Самый выгодный для заказчика',
    desc: 'Выбирается отклик с самой низкой ценой за единицу с учётом персональной скидки. Вся скидка уходит заказчику, вознаграждение дизайнера — 0.',
  },
  {
    value: 'designer',
    title: 'Самый выгодный для дизайнера',
    desc: 'Выбирается отклик с самой большой персональной скидкой в рублях за единицу. Вся скидка — вознаграждение дизайнера, заказчик платит цену поставщика.',
  },
  {
    value: 'optimal',
    title: 'Оптимальный',
    desc: 'Выбирается отклик с самой низкой ценой за единицу с учётом скидки, как в первом режиме. Скидка делится пополам между заказчиком и дизайнером.',
  },
];

/**
 * Окно автоматического выбора откликов по отмеченным позициям: режим и признак «затрагивать
 * позиции с уже выбранным откликом». Сам выбор делает сервер (пакетное действие `auto_choose`),
 * окно лишь возвращает странице параметры. Сгенерировано Claude.
 */
export default {
  name: 'SpecAutoChoosePopupWrappable',
  data() {
    return {
      MODES,
      count: 0,
      mode: 'optimal',
      includeChosen: false,
    };
  },
  methods: {
    init(params = {}) {
      this.count = params.count ?? 0;
    },
    submit() {
      this.$emit('finish', { mode: this.mode, includeChosen: this.includeChosen });
    },
  },
};
</script>

<style scoped lang="scss">
.spec-auto-choose {
  width: 520px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__hint {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__mode {
    display: flex;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid var(--color-super-light);
    border-radius: 8px;
    cursor: pointer;

    &.active {
      border-color: var(--color-accent);
    }
  }

  &__radio {
    margin-top: 3px;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
  }

  &__desc {
    margin-top: 4px;
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__include {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }
}
</style>
